import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { PieChartComponent } from '../../pie-chart.component'
import { DashboardService } from '@app/_services/dashboard.service';
import { first } from 'rxjs/operators';
import { RequestStatitics } from '@app/_models/RequestStatitics';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit {

  constructor(private dashboardService: DashboardService) { }

  // getRequestStatiticsResponse:RequestStatitics[]=[];
  getTopTenEmployerResponse: any;
  getRequestratioResponse: any;
  getYearRevenueResponse: any;
  getDisputeRatioResponse: any;
  getFinancialStatResponse: any;
  getOnlineVerifiers: any;
  yearNew: number;
  yearClosed: number;
  yearDisputes: number;
  weekNew: number;
  weekClosed: number;
  weekDisputes: number;
  monthNew: number;
  monthClosed: number;
  monthDisputes: number;
  firstDate: string;
  lastDate: string;
  firstDateNew: string;
  lastDateNew: string;
  yearDropDown = [];
  selectYear: string;
  monthyear: any;
  monthyearcurrent:any;
  monthyearFormat: string;
  datewise: string = formatDate(new Date, 'yyyy-MM-dd', 'en-US');
  statistics: any = true;
  // @Output() childButtonEvent = new EventEmitter();

  superverifier: any = true;
  
  ngOnInit(): void {

    this.dashboardService.getYear()
    .pipe(first())
    .subscribe(
      data => {
        this.yearDropDown = data.respData;
      },
      error => {
        console.log(error)
      }
    )

    var currentyear = (new Date()).getFullYear();

    var currentMonth = (new Date()).getMonth() + 1;
    var d = currentMonth + '/' + currentyear;
  
    var  currentMonth1=currentMonth.toString().length === 1 ? "0" + currentMonth : currentMonth;;
   
     this.monthyear =  this.monthyear = currentyear+'-'+currentMonth1;//'2021-05';
    //  alert(   this.monthyear)
    // monthyearcurrent
    this.selectYear =currentyear.toString();
    var date = new Date(), y = date.getFullYear(), m = date.getMonth();

    var firstDay = new Date(y, m, 1);
    var lastDay = new Date(y, m + 1, 0);
    this.firstDate = formatDate(new Date(firstDay), 'yyyy-MM-dd', 'en-US');
    this.lastDate = formatDate(new Date(lastDay), 'yyyy-MM-dd', 'en-US');

    this.firstDateNew = formatDate(new Date(firstDay), 'yyyy-MM-dd', 'en-US');
    this.lastDateNew = formatDate(new Date(lastDay), 'yyyy-MM-dd', 'en-US');

    console.log("firstDay response---", firstDay)
    console.log("lastDay response---", lastDay)

    this.dashboardService.getRequestStatitics(currentyear)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getRequestStatitics response---", data)
          //  this.getRequestStatiticsResponse=data.respData.Year;
          //let a= this.getRequestStatiticsResponse.Year.New;
          this.yearNew = data.respData.Year.New;
          this.yearClosed = data.respData.Year.Closed;
          this.yearDisputes = data.respData.Year.Dispute;

          this.weekNew = data.respData.CurrentWeek.New;
          this.weekClosed = data.respData.CurrentWeek.Closed;
          this.weekDisputes = data.respData.CurrentWeek.Dispute;

          this.monthNew = data.respData.CurrentMonth.New;
          this.monthClosed = data.respData.CurrentMonth.Closed;
          this.monthDisputes = data.respData.CurrentMonth.Dispute;

          //console.log("New response---", this.getRequestStatiticsResponse)
        },
        error => {
          console.log(error)
        }
      )

    this.dashboardService.getTopTenEmployer(currentyear)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getTopTenEmployer response---", data)
          this.getTopTenEmployerResponse = data.respData;
        },
        error => {
          console.log(error)
        }
      )


    this.dashboardService.getFinancialStat(this.firstDate, this.lastDate)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getFinancialStat response---", data)
          this.getFinancialStatResponse = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    this.dashboardService.getOnlineVerifiers(this.firstDate, this.lastDate)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getOnlineVerifiers response---", data)
          this.getOnlineVerifiers = data.respData;
        },
        error => {
          console.log(error)
        }
      )

  }

  firstDateChange() {
    this.dashboardService.getFinancialStat(this.firstDate, this.lastDate)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getFinancialStat response---", data)
          this.getFinancialStatResponse = data.respData;
        },
        error => {
          console.log(error)
        }
      )

  }

  lastDateChange() {
    this.dashboardService.getFinancialStat(this.firstDate, this.lastDate)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getFinancialStat response---", data)
          this.getFinancialStatResponse = data.respData;
        },
        error => {
          console.log(error)
        }
      )

  }

  firstDateChangeNew() {
    this.dashboardService.getOnlineVerifiers(this.firstDateNew, this.lastDateNew)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getOnlineVerifiers response---", data)
          this.getOnlineVerifiers = data.respData;
        },
        error => {
          console.log(error)
        }
      )

  }

  lastDateChangeNew() {
    this.dashboardService.getOnlineVerifiers(this.firstDateNew, this.lastDateNew)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getOnlineVerifiers response---", data)
          this.getOnlineVerifiers = data.respData;
        },
        error => {
          console.log(error)
        }
      )

  }
  changemonth() {
    var splitted = this.monthyear.split("-");
    var year = splitted[0];
    var month = splitted[1];
    this.monthyearFormat = month + '/' + year;
    //alert(month+'/'+year);
  }

  changedate() {
    this.datewise;
    //alert(this.datewise);

  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }
  yearChage() {
    //this.childButtonEvent.emit({ year: this.selectYear });
    this.selectYear = this.selectYear;
    this.dashboardService.getRequestStatitics(this.selectYear)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getRequestStatitics response---", data)
          this.yearNew = data.respData.Year.New;
          this.yearClosed = data.respData.Year.Closed;
          this.yearDisputes = data.respData.Year.Dispute;

          this.weekNew = data.respData.CurrentWeek.New;
          this.weekClosed = data.respData.CurrentWeek.Closed;
          this.weekDisputes = data.respData.CurrentWeek.Dispute;

          this.monthNew = data.respData.CurrentMonth.New;
          this.monthClosed = data.respData.CurrentMonth.Closed;
          this.monthDisputes = data.respData.CurrentMonth.Dispute;

          //console.log("New response---", this.getRequestStatiticsResponse)
        },
        error => {
          console.log(error)
        }
      )


    this.dashboardService.getTopTenEmployer(this.selectYear)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getTopTenEmployer response---", data)
          this.getTopTenEmployerResponse = data.respData;
        },
        error => {
          console.log(error)
        }
      )




    this.dashboardService.getFinancialStat(this.firstDate, this.lastDate)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getFinancialStat response---", data)
          this.getFinancialStatResponse = data.respData;
        },
        error => {
          console.log(error)
        }
      )
  }

  getTab(tab) {
    if(tab=='statistics')
    {
    this.statistics=true;
    }
    else
    {
      this.statistics=false;
    }
  }



}
